import storageService from '../services/storageService';

export const authHeader = () => {
  const workspaceId = localStorage.getItem('active_workspace_id');
  const headers = {
    AuthAPI: `Bearer ${storageService.getToken()}`,
    Device: `TMR`,
  };
  if (workspaceId) {
    headers['X-TMR-Workspace-Id'] = workspaceId;
  }
  return {
    common: headers,
  };
};

export const deviceHeader = () => {
  return {
    common: {
      Device: `TMR`,
    },
  };
};
